import React from 'react';

function PlusLight() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.75 1V9.25H19C19.375 9.25 19.75 9.625 19.75 10C19.75 10.4219 19.375 10.75 19 10.75H10.75V19C10.75 19.4219 10.375 19.75 10 19.75C9.57812 19.75 9.25 19.4219 9.25 19V10.75H1C0.578125 10.75 0.25 10.4219 0.25 10C0.25 9.625 0.578125 9.25 1 9.25H9.25V1C9.25 0.625 9.57812 0.25 10 0.25C10.375 0.25 10.75 0.625 10.75 1Z" fill="currentColor" />
    </svg>
  );
}

export { PlusLight };
